import { Box, Grid, makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import React from "react"
import Image from "gatsby-plugin-sanity-image"
const useStyles = makeStyles(theme => ({
  box: {
    color: theme.palette.common.white,
  },
  white: {
    color: theme.palette.common.white,
  },

  numberDiv: {
    zIndex: 2,
    backfaceVisibility: "hidden",
    position: "absolute",
    left: "8px",
    top: "-18px",
  },
  numberSpan: {
    padding: "4px 8px",
    backgroundColor: "#db0a41db",
    color: theme.palette.common.white,
  },

  flipCard: {
    height: 300,
    perspective: "1000px",
    "&:hover": {
      "& $flipCardInner": {
        transform: "rotateY(180deg)",
      },
    },
  },

  flipCardInner: {
    boxShadow: theme.shadows[15],
    position: "relative",
    width: "100%",
    height: "100%",
    textAlign: "center",
    transition: "transform 0.8s",
    transformStyle: "preserve-3d",
  },

  flipCardFB: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
  },

  flipCardFront: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1),

    backgroundColor: theme.palette.secondary.dark,
  },

  flipCardBack: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.secondary.dark,
    overflowX: "hidden",
    overflowY: "auto",
    transform: "rotateY(180deg)",
  },
  marginAuto: {
    marginTop: "auto",
    marginBottom: "auto",
  },
}))
const PlayerCard = ({ name, number, position, description, image }) => {
  const classes = useStyles()
  return (
    <>
      <Grid item xs={6} sm={4} md={3}>
        <div className={classes.flipCard}>
          <div className={classes.flipCardInner}>
            <div className={classes.numberDiv}>
              <Typography
                component="span"
                variant="h6"
                className={classes.numberSpan}
              >
                {number}
              </Typography>
            </div>
            <div className={clsx(classes.flipCardFB, classes.flipCardFront)}>
              <Box height={240} width={"100%"}>
                <Image
                  {...image}
                  height={240}
                  style={{
                    width: "100%",
                    height: "240px",
                    objectFit: "cover",
                    position: "relative",
                  }}
                />
              </Box>

              <Box flexDirection="column" flexGrow={1} display="flex">
                <Typography
                  variant="h5"
                  className={clsx(classes.marginAuto, classes.white)}
                >
                  {name}
                </Typography>
              </Box>
            </div>
            <div className={clsx(classes.flipCardFB, classes.flipCardBack)}>
              <Box pt={2}>
                <Typography variant="h4" className={classes.white}>
                  {name}
                </Typography>
                <Typography variant="body1" className={classes.white}>
                  {description}
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      </Grid>
    </>
  )
}

export default PlayerCard
